import { EventKey } from "@gp/models";
import {
	constants,
	getSortedEventKeysBySpecifierValue,
	Selector,
	SportSelectors,
} from "@gp/offer";
import { ColumnType, OfferColumnConfigurationResult } from "@gp/components";

export function getHistoryOfferColumns(
	eventKeys: EventKey[],
	selectors: SportSelectors,
	numberOfColumns: number = 4
): OfferColumnConfigurationResult {
	const result = new OfferColumnConfigurationResult();

	if (selectors == null) {
		return result;
	}

	Object.keys(selectors)
		.filter((col) => col <= `${numberOfColumns}`)
		.forEach((col: string) => {
			const selector: Selector = selectors[col];

			if (selector == null) {
				result.columns.push({ id: col, type: ColumnType.EMPTY });
				return;
			}

			if (selector.bettingTypes.includes(constants.resultPlaceholder)) {
				result.columns.push({ id: col, type: ColumnType.RESULT });
				return;
			}

			const matchingKeys = selector.bettingTypes.flatMap((bt) =>
				eventKeys.filter((ek) => ek.bettingType.abrv === bt)
			);
			const sorted = getSortedEventKeysBySpecifierValue(matchingKeys);
			const columnKey = sorted[0];

			if (columnKey == null) {
				result.columns.push({ id: col, type: ColumnType.EMPTY });
				return;
			}

			result.columns.push({
				id: columnKey.id,
				type: ColumnType.TIP,
				componentProps: {
					offerKeyId: columnKey.id,
					bettingType: columnKey.bettingType,
					tips: selector.tips,
				},
			});

			result.nonEmptyColumns += 1;
			result.isEmpty = false;
		});

	return result;
}
